// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"7adb01ac","684":"94be1877"}[chunkId] + ".chunk.js";
};